import { api } from '@fno/service/global.js'

export const getAffiliations = ({ schoolId }) => api
    .get(`/v2/schools/${schoolId}/affiliations`)
    .then(response => response.data)

export const patchAffiliations = ({ affiliations }) => api
    .patch(`/v2/schools/${affiliations.meta.schoolId}/affiliations`, { data: affiliations })
    .then(response => response.data)

